<template>
    <div class="row">
		<fieldset>
			<legend>Produção Científica</legend>
			<fieldset>
				<legend>Itens cadastrados</legend>
				<div class="row centered">
					<table class="table-responsive highlight striped ">
						<col width="5%">
						<col width="50%">
						<col width="20%">
						<col width="20%">
						<col width="5%">
						<thead>
							<th></th>
							<th>Tipo de Atuação</th>
							<th>Quantidade</th>
							<th>PDF</th>
							<th></th>
						</thead>
						<tbody>
							<tr v-for="(atuacao, index) in project.curriculo.atuacoes"  v-if="atuacao.atuacao.tipo == 'produção científica'">
								<td></td>
								<td>{{atuacao.atuacao['nome']}}</td>
								<td>{{atuacao['quantidade']}}</td>
								<td v-if="atuacao['pdf']">
									<a :href="'/curriculos/atuacoes/pdf/' + atuacao['id']" class="btn" target='_blank'>
										<i class="material-icons left">assignment_returned</i>Visualizar PDF
									</a>
								</td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
			</fieldset>

			<fieldset>
				<legend>Avaliação</legend>
				<div class="row col s12">
					<span>{{title}}</span>
				</div>
				<div class="row">
					<div class="input-field col s10">
						<label class="active">Itens</label>
						<br />
						<select class="browser-default" v-model="selectedItemNome" v-if="options && options.length">
							<option v-for="(option) in options" :key="option.id" :value="option.nome">
								{{option.nome}}
							</option>
						</select>

					</div>
					<div class="input-field col s2">
						<br />
						<button class="btn" @click.prevent="addItem()">
							<i class="material-icons"> add </i>
						</button>
					</div>
				</div>
				<avaliacao-curriculo-item-producao-add-item-form v-if="showForm" @add-new-item="addNewItem" :pontos="pontosItemOutros"/>
				<base-card
					v-for="(item,index) in itens" :key="index"
				>
					<span slot='title'>
						{{item.nome}}
					</span>
					<span class="blue-text" slot="descricao" id="descricao">
						Pontuação:{{item.pontos}}
					</span>
					<a href="#notas" slot="action" class="red-text" @click="removerItem(item)">
						<i class="material-icons">
							clear
						</i>
					</a>
				</base-card>
				<div class="row">
					<div class="col s16">
						<h5>
							<span>Nota: {{nota}}</span>
						</h5>
					</div>
				</div>
			</fieldset>
		</fieldset>
		<br>
		<div class='row'>
			<div class="col s6">
                    <button
                    id="avaliar"
                    type="button"
                    class="btn"
                    @click.prevent="avaliar()"
                    name="btnAvaliar"
                    >
                    Avaliar
                    </button>
			</div>
		</div>
    </div>
</template>
<script>
    import AvaliacaoCurriculoItemProducaoAddItemForm from './AvaliacaoCurriculoItemProducaoAddItemForm.vue';
    import BaseCard from './BaseCard.vue';
    import { mapState } from 'vuex';
    export default {
        name: 'AvaliacaoCurriculoItemProducao',
        components:{
            BaseCard,
            AvaliacaoCurriculoItemProducaoAddItemForm
        },
        data(){
            return {
                nota:0,
                notaMax:0,
                selectedItemNome:'',
                showForm:false
            }
        },
        computed:{
            ...mapState(['project']),
            pontosItemOutros(){
                return (this.options.filter(e=>e.id==13))[0]['pontos'];
            },
            itens(){
                try {
                    if(this.project.avaliacao.avaliacao_curriculo){
                        return JSON.parse(this.project.avaliacao.avaliacao_curriculo).item_producao;
                    }
                    else{
                        return [];
                    }
                } catch (error) {
                    return this.project.avaliacao.avaliacao_curriculo.item_producao;
                }

            }
        },
        asyncComputed:{
            async title(){
                try {
                    let {data}=await this.$http.get('/api/mensagens/13');
                    return data.mensagem;
                } catch (error) {
                    console.log(error);
                }
            },
            async options(){
                try {
                    let{data}=await this.$http.get('/api/avaliacaoCurriculo/producao');
                    return data;
                } catch (error) {
                    console.log(error);
                }
            }
        },
        methods:{
            async getNotaMax(){
                try {
                    let {data}=await this.$http.get('/api/nova_avaliacao/notaMax/4');
                    return data[0].nota_max;
                } catch (error) {
                    console.log(error);
                }
            },
            sum(){
                if(this.itens && this.itens.length && this.notaMax != 0){
                    let total=(this.itens.map(e=>e.pontos)).reduce((acc,currentValue)=>Number(acc)+Number(currentValue));
                    if(total > this.notaMax){
                       this.$set(this,'nota',this.notaMax);
                    }
                    else{
                        this.$set(this,'nota',total);
                    }

                }
                else{
                    this.$set(this,'nota',0);
                }
                return true;
            },
            removerItem(item){
                let index=this.itens.findIndex(e=>e.nome.localeCompare(item.nome) == 0);
                this.itens.splice(index,1);
                this.sum();
            },
            hasItem(nome){
                if(this.itens && this.itens.length){
                    return this.itens.filter(e=>e.nome.toUpperCase().trim() == nome.toUpperCase().trim()).length;
                }
                else{
                    return false;
                }
            },
            addNewItem(payload){
                if(!this.hasItem(payload.nome)){
                    this.itens.push(payload);
                    this.sum();


                    this.$set(this,'showForm',false);
                }else{
                    showMsg('Item já incluso!');
                }
            },
            addItem(){

                let item =this.options.find(e=>{
                    return e.nome.localeCompare(this.selectedItemNome) == 0
                });
                if(item.nome.trim() == 'Outro (especifique)'.trim()){
                    this.$set(this,'showForm',true);
                }
                else{
                    this.$set(this,'showForm',false);
                    if(!this.hasItem(item.nome)){
                        this.itens.push(item);
                        this.sum();


                    }
                    else{
                        showMsg('Item já incluso!');
                    }
                }


            },
            avaliar(){
                this.$set(this.itens,'nota',this.nota);
                this.$emit('avaliar-item',this.itens);
            }
        },
        created(){
            try {
               this.getNotaMax().then((notaMax)=>{
                   this.$set(this,'notaMax',notaMax);
                   this.sum();

               });

            } catch (error) {
                console.log(error);
            }

        }

    }
</script>